import { combineReducers } from 'redux'
import { generalSettingsReducer } from './general-settings'
import { rwaConditionsReducer } from './rwa-conditions'
import { rwaInsightsReportsReducer } from './rwa-insights-reports'

export const platformSettingsReducer = combineReducers({
    rwaConditions: rwaConditionsReducer,
    rwaInsightsReports: rwaInsightsReportsReducer,
    generalSettings: generalSettingsReducer
})
